import { render, staticRenderFns } from "./ProfitStatement.vue?vue&type=template&id=6c7e628a&scoped=true"
import script from "./ProfitStatement.vue?vue&type=script&lang=js"
export * from "./ProfitStatement.vue?vue&type=script&lang=js"
import style0 from "./ProfitStatement.vue?vue&type=style&index=0&id=6c7e628a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7e628a",
  null
  
)

export default component.exports